import React from 'react';
import { useIntl } from 'react-intl';
import { ProposalAIPrimaryButton } from './ProposalAIPrimaryButton';
import { ServiceSegmentAIPanel } from './ServiceSegmentAIPanel';
import { useServiceSegmentAI } from '../hooks';

interface Props {
  index: number;
}

export const ServiceSegmentAI: React.FC<Props> = ({ index }) => {
  const { formatMessage } = useIntl();
  const serviceAI = useServiceSegmentAI(index);

  if (!serviceAI.shouldRender) {
    return null;
  }

  return (
    <div className="proposal-service-ai">
      {!serviceAI.isOpen ? (
        <ProposalAIPrimaryButton
          label={formatMessage({ id: 'proposal-ai.service.open' })}
          onClick={serviceAI.handleOpen}
          btnSelector="proposal-ai-service-open"
          style="outline"
          size="med"
          className="proposal-service-ai__trigger"
        />
      ) : (
        <ServiceSegmentAIPanel
          index={index}
          prompt={serviceAI.prompt}
          generated={serviceAI.generated}
          isGenerating={serviceAI.isGenerating}
          isGeneratedStale={serviceAI.isGeneratedStale}
          onPromptChange={serviceAI.setPrompt}
          onGenerate={serviceAI.handleGenerate}
          onApply={serviceAI.handleApply}
          onCancel={serviceAI.resetState}
        />
      )}
    </div>
  );
};
